import AgentService from "@/service/AgentService";
import PlayerService from "@/service/PlayerService";
import TeamService from "@/service/TeamService";
import CoachingStaffService from "@/service/CoachingStaffService";
import axios from 'axios'
import store from "../store";
import { Action } from "@/whatchat/index";
import Vue from 'vue'

export default class AuthService {
    config = {
        headers: { Authorization: `Bearer fake` }
    };
    login(email, password) {
        return new Promise((resolve, reject) => {
            const data = "grant_type=password&userName=" + email + "&password=" + password + "&from=transfer";
            axios.post(Vue.prototype.$serviceBaseUrl + '/auth/login', data, this.config)
                .then(res => {
                    const profileParsed = JSON.parse(res.data.user);
                    const userProfile = profileParsed.Profile;

                    localStorage.setItem('userImageUrl', profileParsed.UserImageUrl);
                    localStorage.setItem('userProfile', userProfile);
                    localStorage.setItem('userId', profileParsed.Id);
                    localStorage.setItem('userEmail', profileParsed.Email);
                    localStorage.setItem('ph', profileParsed.PasswordHash);
                    localStorage.setItem('token', res.data.access_token);

                    //this.loginChat(profileParsed.Email, profileParsed.PasswordHash);

                    switch (userProfile) {
                        case Vue.prototype.$agentProfileId:
                            new AgentService().getAgentProfile(profileParsed.Id).then(
                                res => {
                                    localStorage.setItem('userName', res.data.Name);
                                    localStorage.setItem('userRole', res.data.AgentType);

                                    resolve();
                                },
                                function (err) {
                                    reject("Internal error");
                                }
                            );
                            break;

                        case Vue.prototype.$playerProfileId:
                            new PlayerService().getPlayerProfile(profileParsed.Id).then(
                                res => {
                                    localStorage.setItem('userName', res.data.Name);

                                    resolve();
                                },
                                function (err) {
                                    reject("Internal error");
                                }
                            );
                            break;

                        case Vue.prototype.$teamProfileId:
                            new TeamService().getTeam(profileParsed.Id).then(
                                res => {
                                    localStorage.setItem('userName', res.data.Name);

                                    resolve();
                                },
                                function (err) {
                                    reject("Internal error");
                                }
                            );
                            break;

                        case Vue.prototype.$coachingStaffProfileId:
                            new CoachingStaffService().getCoachingStaffProfile(profileParsed.Id).then(
                                res => {
                                    localStorage.setItem('userName', res.data.Name);

                                    resolve();
                                },
                                function (err) {
                                    reject("Internal error");
                                }
                            );
                            break;

                        default:
                            reject("User not allowed");
                            break;
                    }
                })
                .catch(error => {
                    if (error.response)
                        reject(error.response.data.error_description);
                    else
                        reject("Internal error");
                })
        })
    }
    loginChat(email, passwordHash) {
        const values = {
            email: email,
            password: passwordHash,
        };

        store.dispatch(Action.AUTH_REQUEST, values).then(
            (resp) => {
            },
            (err) => { 
            }
        );
    }
    logout() {
        localStorage.removeItem('userImageUrl');
        localStorage.removeItem('userProfile');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userRole');
        localStorage.removeItem('ph');
        localStorage.removeItem('token');

        this.logoutChat();
    }
    logoutChat() {
        store.dispatch(Action.AUTH_LOGOUT).then(
            (resp) => {
            },
            (err) => {
            }
        );
    }
    signup(name, surname, email, password, profile, language, subProfile, partnerId) {
        const data = {
            Email: email,
            Password: password,
            Profile: profile,
            Name: name,
            Surname: surname,
            Language: language,
            BaseUrl: Vue.prototype.$rootSiteUrl,
            SubProfile: subProfile,
            PartnerId: partnerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/Register', data, this.config);
    }
    confirmEmail(code, language) {
        const data = {
            Code: code,
            Language: language,
            BaseUrl: Vue.prototype.$rootSiteUrl
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/ConfirmEmail', data, this.config);
    }
    recoverPassword(email, language) {
        const data = {
            Email: email,
            Language: language,
            BaseUrl: Vue.prototype.$rootSiteUrl
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/StartResetPassword', data, this.config);
    }
    resetPassword(token, email, newPassword) {
        const data = {
            Code: token,
            Email: email,
            NewPassword: newPassword
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/ConfirmResetPassword', data, this.config);
    }
    getUserBearerToken() {
        return localStorage.getItem('token');
    }
    getUserProfile() {
        return localStorage.getItem('userProfile');
    }
    getUserAvatarUrl() {
        return localStorage.getItem('userImageUrl');
    }
    getpasswordHash() {
        return localStorage.getItem('ph');
    }
    setUserAvatarUrl(avatarUrl) {
        localStorage.removeItem('userImageUrl');
        localStorage.setItem('userImageUrl', avatarUrl);
    }
    getUserId() {
        return localStorage.getItem('userId');
    }
    getUserName() {
        return localStorage.getItem('userName');
    }
    getUserEmail() {
        return localStorage.getItem('userEmail');
    }
    getUserRole() {
        return localStorage.getItem('userRole');
    }
    getUserInfo(email, password) {
        const data = {
            Email: email,
            Password: password
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/GetUserInfo', data, this.config);
    }
    registerPlayer(player) {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Account/RegisterPlayerFromTransfer', player, this.config);
    }
}